import { n as s } from "./property-9daa16cd.mjs";
import { r as u } from "./state-7560d4dc.mjs";
import { i as w, b as y, E as g, x as l, a as m, r as x } from "./createReactComponent-58f9bea8.mjs";
import { e as v } from "./class-map-2994e95e.mjs";
import { c as b, o as f, e as O, s as E, d as $ } from "./tooltip-cb602d1f.mjs";
import { b as k, B as L, a as C, r as T } from "./button-7600b6ca.mjs";
import { I as z, r as A } from "./icon-c572aa57.mjs";
import { r as D } from "./icon-button-a9d2a2d1.mjs";
var a = ((n) => (n.container = "dropdown--container", n.trigger = "dropdown--trigger", n.popover = "dropdown--popover", n))(a || {}), P = Object.defineProperty, B = Object.getOwnPropertyDescriptor, o = (n, e, t, r) => {
  for (var h, p = r > 1 ? void 0 : r ? B(e, t) : e, d = n.length - 1; d >= 0; d--)
    (h = n[d]) && (p = (r ? h(e, t, p) : h(p)) || p);
  return r && p && P(e, t, p), p;
};
const c = ["resize", "scroll", "exo.closeDropdown"];
class i extends g {
  constructor() {
    super(...arguments), this.isOpen = !1, this.icon = "delete", this.text = "", this.flavor = k.BASE, this.type = L.PRIMARY, this.disabled = !1, this.align = "left", this.gap = 2, this.size = C.DEFAULT, this.label = "", this.hidePrefix = !1, this.useDisplay = !1, this.autoOpen = !1, this.tooltipText = "", this.width = "var(--exo-size-3)", this.circular = !1, this.prefixIconLabel = "", this.menuGroupElement = null, this.keepOpen = !1, this.onToggle = (e) => {
      var t, r;
      e.stopPropagation(), this.disabled || (this.isOpen || window.dispatchEvent(new CustomEvent("exo.closeDropdown")), this.isOpen = !this.isOpen, this.isOpen ? (t = this.menuGroupElement) == null || t.setAttribute("isMenuOpen", "") : (r = this.menuGroupElement) == null || r.removeAttribute("isMenuOpen"), this.dispatchCustomEvent("open-dropdown"));
    }, this.hide = () => {
      var e;
      this.isOpen = !1, (e = this.menuGroupElement) == null || e.removeAttribute("isMenuOpen"), this.dispatchCustomEvent("close-dropdown"), this.autoOpen && this.removeAttribute("auto-open");
    }, this.hideOnWindowClick = (e) => {
      e.target !== this && this.hide();
    }, this.hideOnClick = (e) => {
      const t = e.target;
      this.contains(t) || t.nodeName === "EX-FILTER" || this.hide();
    }, this.hideOnEscape = (e) => {
      e.key === "Escape" && this.hide();
    }, this.adjustPosition = () => {
      const e = this.renderRoot.querySelector(`.${a.trigger}`), t = this.renderRoot.querySelector(`.${a.popover}`);
      if (!e || !t)
        return;
      const r = e.getBoundingClientRect();
      this.dropdownElement = t, b(e, t, { strategy: "fixed", middleware: [f(() => ({ mainAxis: this.gap })), O({ allowedPlacements: this.align === "right" ? ["bottom-start", "top-start"] : ["bottom-start", "top-start", "bottom-end", "top-end"] }), E({ apply: ({ rects: h }) => {
        t.style.width = `${h.reference.width}px`;
      } })] }).then(({ x: h, y: p }) => {
        if (t.style.top = `${p}px`, t.style.minWidth = `${this.width}`, this.align === "right") {
          const d = t.offsetWidth;
          t.style.left = h + r.width - d + "px";
        } else
          t.style.left = `${h}px`;
      });
    };
  }
  handleAutoOpen() {
    var e;
    !this.autoOpen || this.isOpen || this.disabled || (this.isOpen = !0, this.dropdownElement && ((e = this.menuGroupElement) == null || e.setAttribute("isMenuOpen", "")));
  }
  connectedCallback() {
    super.connectedCallback(), c.forEach((e) => {
      window.addEventListener(e, this.hide);
    }), this.useDisplay ? (window.addEventListener("keyup", this.hideOnEscape), window.addEventListener("click", this.hideOnClick)) : (window.addEventListener("click", this.hideOnWindowClick), window.addEventListener("keyup", this.hideOnEscape));
  }
  disconnectedCallback() {
    this.stop(), super.disconnectedCallback(), c.forEach((e) => {
      window.removeEventListener(e, this.hide);
    }), window.removeEventListener("click", this.hideOnClick), window.removeEventListener("click", this.hideOnWindowClick), window.removeEventListener("keyup", this.hideOnEscape);
  }
  start() {
    const e = this.renderRoot.querySelector(`.${a.trigger}`), t = this.renderRoot.querySelector(`.${a.popover}`);
    e && t && (this.cleanup = $(e, t, () => {
      this.adjustPosition();
    }));
  }
  stop() {
    this.cleanup && (this.cleanup(), this.cleanup = void 0);
  }
  updated(e) {
    super.updated(e), this.handleAutoOpen(), e.has("isOpen") && this.isOpen ? this.start() : this.isOpen || this.stop(), e.has("keepOpen") && (this.keepOpen ? c.forEach((t) => {
      window.removeEventListener(t, this.hide);
    }) : c.forEach((t) => {
      window.addEventListener(t, this.hide);
    }));
  }
  getIcon() {
    return this.icon ? l`<ex-icon
        icon="${this.icon}"
        slot="prefix"
        label=${this.prefixIconLabel}
      ></ex-icon>` : "";
  }
  getTrigger() {
    return this.text ? l`
        <ex-button
          ?disabled=${this.disabled}
          flavor=${this.flavor}
          size="${this.size}"
          type="${this.type}"
          @click="${this.onToggle}"
          exportparts="button"
        >
          ${this.hidePrefix ? m : this.getIcon()} ${this.text}
          <ex-icon
            icon="${this.isOpen ? "Up caret" : "Down caret"}"
            slot="suffix"
          ></ex-icon>
        </ex-button>
      ` : l`
      <ex-icon-button
        icon="${this.icon}"
        hide-browser-tooltip
        ?disabled=${this.disabled}
        type="${this.type}"
        ?circular=${this.circular}
        variant="${z.DEFAULT}"
        @click="${this.onToggle}"
        tooltipText=${this.tooltipText}
        size=${this.size}
      >
      </ex-icon-button>
    `;
  }
  handleSlotChange(e) {
    const t = [...e.target.assignedElements({ flatten: !0 })];
    t.length && (this.menuGroupElement = t[0].querySelector("ex-menu-item-group"));
  }
  render() {
    const e = `max-width: ${this.width}; min-width: ${this.width}`;
    return l`
      <div class="${a.container}" aria-label="${this.label}">
        <div class="${a.trigger}">
          <slot name="anchor" @click="${this.onToggle}">
            ${this.getTrigger()}</slot
          >
        </div>
        ${this.disabled ? m : l`
              <div
                class=${v({ [a.popover]: !0, show: this.isOpen, hide: !this.isOpen })}
              >
                <slot style="${e}" @slotchange=${this.handleSlotChange}>
                </slot>
              </div>
            `}
      </div>
    `;
  }
}
i.styles = w`
    ${y(`:host{--exo-component-dropdown-popup-min-height: var(--exo-size-1)}:host .dropdown--popover{position:fixed;display:none;min-width:var(--exo-size-3);min-height:var(--exo-component-dropdown-popup-min-height);z-index:var(--exo-z-index-select-menu-dropdown)}:host .dropdown--popover.show{display:block}:host .dropdown--popover slot{display:block}:host ex-button::part(button){height:var(--exo-spacing-x-large);display:flex;justify-content:space-between}
`)}
  `, o([u()], i.prototype, "isOpen", 2), o([s()], i.prototype, "icon", 2), o([s()], i.prototype, "text", 2), o([s()], i.prototype, "flavor", 2), o([s()], i.prototype, "type", 2), o([s({ type: Boolean })], i.prototype, "disabled", 2), o([s()], i.prototype, "align", 2), o([s()], i.prototype, "gap", 2), o([s()], i.prototype, "size", 2), o([s()], i.prototype, "label", 2), o([s({ attribute: "hide-prefix", type: Boolean })], i.prototype, "hidePrefix", 2), o([s({ attribute: "use-display", type: Boolean })], i.prototype, "useDisplay", 2), o([s({ attribute: "auto-open", type: Boolean })], i.prototype, "autoOpen", 2), o([u()], i.prototype, "dropdownElement", 2), o([s()], i.prototype, "tooltipText", 2), o([s()], i.prototype, "width", 2), o([s({ type: Boolean })], i.prototype, "circular", 2), o([s({ type: String })], i.prototype, "prefixIconLabel", 2), o([s({ type: Boolean, reflect: !0 })], i.prototype, "keepOpen", 2);
const F = (n = "") => {
  x("ex-dropdown", i, n), T(n), A(n), D(n);
};
export {
  i as D,
  F as r
};
